import { cn } from '@/lib/utils'
import { Container, Section, SectionHeader } from '@/ui/components'
import { memo } from 'react'
import Video from './components/Video'
import './style.css'
import { SectionVideoProps } from './type'

const SectionVideo = ({
  videos,
  section,
  data,
  description,
  sectionHeaderData
}: SectionVideoProps) => {
  if (!videos || !videos.length) {
    return null
  }

  return (
    <Section data={section} className="s-section-video gap-md flex flex-col">
      <SectionHeader {...sectionHeaderData} />
      <Container>
        <Video poster={data?.content?.images?.[0]?.publicUrl} videos={videos} />
        {description && (
          <p className={cn('py-md text-sm-regular text-neutral-400')}>
            {description}
          </p>
        )}
      </Container>
    </Section>
  )
}

export default memo(SectionVideo)
